import Api from '~/api'
import { resetForm, formSuccess, isLoading } from '~/form/actions'
import { registerEvents } from '~/event/actions'
import { push } from 'react-router-redux'
import { Map, List, fromJS } from 'immutable'

/**
 * Fetch full project
 */

export function fetchItem(id) {
  return (dispatch, getState) => {
    dispatch({
      type: 'PROJECT_FETCH_ITEM_LOADING',
      isLoading: true,
    })

    Api.get(`/project/${id}/full`)
      .then(({ data }) => {
        if (data.success)
          return dispatch({
            type: 'PROJECT_FETCH_ITEM_SUCCESS',
            item: data.item,
          })

        dispatch({
          type: 'PROJECT_FETCH_ITEM_ERROR',
          hasErrored: true,
          message: data.message || 'Error when fetching project',
        })
      })
      .catch(err =>
        dispatch({
          type: 'PROJECT_FETCH_ITEM_ERROR',
          hasErrored: true,
          message: err.message,
        })
      )
  }
}

/**
 * Update project
 */

export function updateProject(values, formId) {
  return async dispatch => {
    try {
      dispatch({
        type: 'PROJECT_UPDATE_LOADING',
        loading: true,
      })

      let { data } = await Api.patch(`/project/${values.get('id')}`, { item: values })

      dispatch(registerEvents(data.events))

      if (data.success) {
        dispatch(resetForm(formId))
        dispatch({
          type: 'PROJECT_UPDATE_SUCCESS',
          item: data.item,
        })
        dispatch(push(`/project/${data.item.id}`))
      } else {
        dispatch({
          type: 'PROJECT_UPDATE_ERROR',
          message: data.message,
        })
        dispatch({
          type: 'FORM_SUBMIT_VALIDATION_ERROR',
          formId,
          errors: fromJS(data.errors || {}),
          messages: fromJS(data.messages || []),
        })
      }
    } catch (err) {
      console.log(err)
      dispatch({
        type: 'PROJECT_UPDATE_ERROR',
        message: err.message || 'Error when creating project',
      })
    }
  }
}

/**
 * Order editor
 */

export function orderEditorSave(values, formId) {
  return async dispatch => {
    try {
      dispatch(orderEditorSaving(true))
      let { data } = await Api.patch(`/project/${values.get('id')}/orders`, {
        interviews: values.get('interviews', List()).toJS(),
      })
      dispatch(registerEvents(data.events))

      if (!data.success) {
        dispatch({
          type: 'FORM_SUBMIT_VALIDATION_ERROR',
          formId,
          errors: fromJS(data.errors || {}),
          messages: fromJS(data.messages || []),
        })
      } else {
        dispatch(formSuccess(formId))
      }

      dispatch(orderEditorSaving(false))
    } catch (err) {
      console.log(err)
      dispatch({
        type: 'FORM_SUBMIT_VALIDATION_ERROR',
        formId,
        errors: fromJS(data.errors || {}),
        messages: fromJS([err.message]),
      })
    }
  }
}

export function orderEditorSaving(saving) {
  return {
    type: 'PROJECT_ORDER_EDITOR_SAVING',
    saving,
  }
}

/**
 * Create interview
 */

export function createInterview(projectId, interviewData) {
  return async dispatch => {
    try {
      dispatch({
        type: 'PROJECT_CREATE_INTERVIEW_LOADING',
        loading: true,
      })

      let { data } = await Api.post(`/project/${projectId}/interview`, { data: interviewData })

      dispatch(registerEvents(data.events))

      if (!data.success) throw Error(data.message)

      dispatch({
        type: 'PROJECT_CREATE_INTERVIEW_SUCCESS',
        item: data.item,
      })
    } catch (err) {
      console.log(err)
      dispatch({
        type: 'PROJECT_CREATE_INTERVIEW_ERROR',
        message: err.message || 'Error when creating interview',
      })
    }
  }
}

/**
 * Update interview
 */

export function updateInterview(projectId, interviewId, item, events) {
  return async dispatch => {
    try {
      dispatch({
        type: 'PROJECT_UPDATE_INTERVIEW_LOADING',
        loading: true,
      })

      let { data } = await Api.patch(`/project/${projectId}/interview/${interviewId}`, { item, events })

      dispatch(registerEvents(data.events))

      if (!data.success) throw Error(data.message)

      dispatch({
        type: 'PROJECT_UPDATE_INTERVIEW_SUCCESS',
        item: data.item,
      })
    } catch (err) {
      console.log(err)
      dispatch({
        type: 'PROJECT_UPDATE_INTERVIEW_ERROR',
        message: err.message || 'Error when creating project',
      })
    }
  }
}

/**
 * Deliver interview
 */

export function deliverInterview(projectId, interviewId) {
  return async dispatch => {
    try {
      dispatch({
        type: 'PROJECT_UPDATE_INTERVIEW_LOADING',
        loading: true,
      })

      let { data } = await Api.post(`/project/${projectId}/interview/${interviewId}/deliver`, { deliver: true })
      dispatch(registerEvents(data.events))

      if (!data.success) throw Error(data.message)

      dispatch({
        type: 'PROJECT_UPDATE_INTERVIEW_SUCCESS',
        item: data.item,
      })
    } catch (err) {
      console.log(err)
      dispatch({
        type: 'PROJECT_UPDATE_INTERVIEW_ERROR',
        message: err.message || 'Error when creating project',
      })
    }
  }
}

/**
 * Delete interview
 */

export function deleteInterview(projectId, interviewId) {
  return async dispatch => {
    try {
      dispatch({
        type: 'PROJECT_DELETE_INTERVIEW_LOADING',
        loading: true,
      })

      let { data } = await Api.delete(`/project/${projectId}/interview/${interviewId}`)
      dispatch(registerEvents(data.events))

      if (data.success) throw Error(data.message)

      dispatch({
        type: 'PROJECT_DELETE_INTERVIEW_SUCCESS',
        itemId: data.itemId,
      })
    } catch (err) {
      console.log(err)
      dispatch({
        type: 'PROJECT_DELETE_INTERVIEW_ERROR',
        message: err.message || 'Error when creating project',
      })
    }
  }
}

/**
 * Create interview
 */

export function createApproval(projectId, interviewId, approval_target, order) {
  return async dispatch => {
    try {
      dispatch({
        type: 'PROJECT_CREATE_APPROVAL_LOADING',
        loading: true,
      })

      let { data } = await Api.post(`/project/${projectId}/interview/${interviewId}/approval`, {
        approval_target,
        order,
      })
      dispatch(registerEvents(data.events))

      if (!data.success) throw Error(data.message)

      dispatch({
        type: 'PROJECT_CREATE_APPROVAL_SUCCESS',
        projectId,
        interviewId,
        item: data.item,
      })
    } catch (err) {
      console.log(err)
      dispatch({
        type: 'PROJECT_CREATE_APPROVAL_ERROR',
        message: err.message || 'Error when creating approval',
      })
    }
  }
}

export function updateApproval(projectId, interviewId, approvalId, approval) {
  return async dispatch => {
    try {
      dispatch({
        type: 'PROJECT_UPDATE_APPROVAL_LOADING',
        loading: true,
      })

      let { data } = await Api.patch(`/project/${projectId}/interview/${interviewId}/approval/${approvalId}`, {
        data: approval,
      })
      dispatch(registerEvents(data.events))

      if (!data.success) throw Error(data.message)

      dispatch({
        type: 'PROJECT_UPDATE_APPROVAL_SUCCESS',
        projectId,
        interviewId,
        approvalId,
        item: data.item,
      })
    } catch (err) {
      console.log(err)
      dispatch({
        type: 'PROJECT_UPDATE_APPROVAL_ERROR',
        message: err.message || 'Error when updating approval',
      })
    }
  }
}

export function deleteApproval(projectId, interviewId, approvalId) {
  return async dispatch => {
    try {
      dispatch({
        type: 'PROJECT_DELETE_APPROVAL_LOADING',
        loading: true,
      })

      let { data } = await Api.delete(`/project/${projectId}/interview/${interviewId}/approval/${approvalId}`)
      dispatch(registerEvents(data.events))

      if (!data.success) throw Error(data.message)

      dispatch({
        type: 'PROJECT_DELETE_APPROVAL_SUCCESS',
        projectId,
        interviewId,
        approvalId,
      })
    } catch (err) {
      console.log(err)
      dispatch({
        type: 'PROJECT_DELETE_APPROVAL_ERROR',
        message: err.message || 'Error when deleting approval',
      })
    }
  }
}

export function runApprovalAction(projectId, interviewId, approvalIds, message) {
  return async dispatch => {
    try {
      dispatch({
        type: 'PROJECT_RUN_APPROVAL_ACTION_LOADING',
        loading: true,
      })

      for (let approvalId of approvalIds) {
        let { data } = await Api.post(`/project/${projectId}/interview/${interviewId}/approval/${approvalId}/action`, {
          message,
        })
        dispatch(registerEvents(data.events))

        if (!data.success) throw Error(data.message)

        dispatch({
          type: 'PROJECT_RUN_APPROVAL_ACTION_SUCCESS',
          projectId,
          interviewId,
          approvalId,
          item: data.item,
        })

        dispatch({
          type: 'PROJECT_APPROVAL_ACTION_STATUS',
          approvalId,
          status: 'success',
        })

        setTimeout(
          () =>
            dispatch({
              type: 'PROJECT_APPROVAL_ACTION_STATUS',
              approvalId,
            }),
          2000
        )
      }
    } catch (err) {
      console.log(err)
      dispatch({
        type: 'PROJECT_RUN_APPROVAL_ACTION_ERROR',
        message: err.message || 'Error when running action',
      })
    }
  }
}

export function adminApprove(projectId, interviewId, approvalId) {
  return async dispatch => {
    try {
      dispatch({
        type: 'PROJECT_ADMIN_APPROVAL_LOADING',
        loading: true,
      })

      let { data } = await Api.post(`/project/${projectId}/interview/${interviewId}/approval/${approvalId}/approve`)
      dispatch(registerEvents(data.events))

      if (!data.success) throw Error(data.message)

      dispatch({
        type: 'PROJECT_ADMIN_APPROVAL_SUCCESS',
        projectId,
        interviewId,
        approvalId,
        item: data.item,
      })
    } catch (err) {
      console.log(err)
      dispatch({
        type: 'PROJECT_ADMIN_APPROVAL_ERROR',
        message: err.message || 'Error when deleting approval',
      })
    }
  }
}

/**
 * Tasks
 */

export function createTask(formId, projectId, interviewId, values) {
  return async dispatch => {
    try {
      let { data } = await Api.post(`/project/${projectId}/interview/${interviewId}/task`, { data: values })

      dispatch(registerEvents(data.events))
      dispatch(isLoading(formId, false))
      dispatch(resetForm(formId))

      if (!data.success) throw Error(data.message)

      dispatch({
        type: 'PROJECT_CREATE_TASK_SUCCESS',
        interviewId,
        item,
      })
    } catch (err) {
      console.log(err)
      dispatch({
        type: 'PROJECT_CREATE_TASK_ERROR',
        message: err.message || 'Error when creating project',
      })
    }
  }
}

export function updateTask(projectId, interviewId, taskId, values) {
  return async dispatch => {
    try {
      let { data } = await Api.patch(`/project/${projectId}/interview/${interviewId}/task/${taskId}`, { data: values })
      dispatch(registerEvents(data.events))

      if (data.success) {
        dispatch(updateTaskSuccess(interviewId, taskId, data.item))
        dispatch({
          type: 'PROJECT_UPDATE_TASK_SUCCESS',
          taskId,
          interviewId,
          item: data.item,
        })
      } else {
        throw Error(data.message)
      }
    } catch (err) {
      console.log(err)
      dispatch({
        type: 'PROJECT_UPDATE_TASK_ERROR',
        interviewId,
        taskId,
        message: err.message || 'Error when creating project',
      })
    }
  }
}

export function setSideHidden(hidden = false) {
  localStorage.projectViewSideHidden = hidden
  return {
    type: 'PROJECT_SIDE_VIEW_HIDDEN',
    hidden,
  }
}

/**
 * Burn captions
 */

export function createCaptionBurnJob(projectId, interviewId, captions, video) {
  return async dispatch => {
    try {
      let { data } = await Api.post(`/project/${projectId}/interview/${interviewId}/burn_captions`, { captions, video })

      dispatch(registerEvents(data.events))

      if (!data.success) throw Error(data.message)

      dispatch({
        type: 'PROJECT_BURN_CAPTIONS_SUCCESS',
        interviewId,
      })
    } catch (err) {
      console.log(err)
      dispatch({
        type: 'PROJECT_BURN_CAPTIONS_ERROR',
        message: err.message || 'Error when creating project',
      })
    }
  }
}

/**
 * Connect person to interview
 */

export function managePerson(formId, projectId, personId, values) {
  return async (dispatch, getState) => {
    let { location = {} } = getState().routing || {}
    location.search = ''

    try {
      dispatch({
        type: 'PROJECT_MANAGE_PERSON_LOADING',
        loading: true,
      })

      let task = values.get('create_task') ? values.get('task', Map()).toJS() : undefined
      let person = values.get('person', Map()).toJS()

      let { data } = await Api.post(`/project/${projectId}/person/${personId}`, { task, person })
      dispatch(registerEvents(data.events))

      if (!data.success) throw Error(data.message)

      dispatch(push(location))
      dispatch(resetForm(formId))

      dispatch({
        type: 'PROJECT_MANAGE_PERSON_SUCCESS',
        projectId,
        personId,
        item: data.item,
        task: data.task,
        update_new_interview: data.update_new_interview,
        update_old_interview: data.update_old_interview,
      })
    } catch (err) {
      console.log(err)
      dispatch({
        type: 'PROJECT_MANAGE_PERSON_ERROR',
        message: err.message || 'Error when creating approval',
      })
    }
  }
}
